import store from "@/store";

// El admin siempre puede entrar; el asistente, solo con el permiso habilitado
// (statistics.view, análogo al CRM de órdenes).
const canAccessStats = () =>
  store.getters.isAdmin ||
  (store.state.user?.permissions || []).includes("statistics.view");

const statsRoutes = [
  {
    path: "/stats",
    name: "stats",
    meta: {
      condition: canAccessStats,
      redirectTo: { name: "home" },
    },
    component: () =>
      import(/* webpackChunkName: "stats" */ "../components/stats/Stats.vue"),
  },
];

export default statsRoutes;
